import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, BankAccountConnectionService, PaymentSourceService} from '../_services';
import {FormBuilder} from '@angular/forms';
import {CrudGetComponent} from '../_directives';
import {takeUntil} from 'rxjs/operators';
import {StripeAccountType} from '../_models';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './bank-account-new.component.html'
})
export class BankAccountNewComponent extends CrudGetComponent implements OnInit {
  private accountType: StripeAccountType = StripeAccountType.Main;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected paymentService: PaymentSourceService,
    protected alertService: AlertService,
    private formBuilder: FormBuilder,
    private bankAccountConnectionService: BankAccountConnectionService
  ) {
    super(router, location, route, paymentService, alertService);
    this.title = 'Add New Bank Account';
  }

  ngOnInit() {
    super.ngOnInit();
    this.form = this.formBuilder.group({});

    const queryParams = this.route.snapshot.queryParams;
    this.accountType = +queryParams['stripe_account_type'] || StripeAccountType.Main;
  }

  connectBankAccount() {
    this.loading = true;

    this.bankAccountConnectionService.connectBankAccount(this.accountType)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.alertService.success('Added New Bank Account.', true);
          this.loading = false;
          this.goBack();
        },
        (error) => {
          this.loading = false;
          if (error.cancelled) {
            // User closed the modal without connecting an account
          } else if (error.status === 400 && error.error && 'token' in error.error) {
            this.alertService.error(error.error.token);
          } else if (error.message) {
            this.alertService.error(error.message);
          } else {
            this.handleSubmitError(error);
          }
        }
      );
  }
}
